import React, { useEffect } from "react";
import { Form, Input, Upload, Button, Row, Col, message, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { updateSettings } from "../../../api/discount.service";
import config from '../../../config';

const EditSettingModal = ({ vehicleData, isModalOpen, handleOk, handleCancel, isViewOnly = false }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                ...vehicleData,
                picture: vehicleData.picture
                    ? [
                        {
                            uid: "-1",
                            name: vehicleData.picture.split("\\").pop(),
                            status: "done",
                            url: config.API_URL + '/' + vehicleData.picture,
                        },
                    ]
                    : [],
            });
        }
    }, [vehicleData, form]);

    const onFinish = async (values) => {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
            if (key === "picture" && values.picture && values.picture.length > 0) {
                if (values.picture[0].originFileObj) {
                    formData.append(key, values.picture[0].originFileObj);
                }
            } else {
                formData.append(key, values[key]);
            }
        });

        try {
            await updateSettings(formData);
            message.success("Setting updated successfully!");
        } catch (error) {
            message.error(error);
            console.error("Error:", error);
        }
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
            message.error("You can only upload image files!");
        }
        return isImage ? false : Upload.LIST_IGNORE;
    };

    return (
        <Modal className="vt-modal" footer={null} destroyOnClose title={`${isViewOnly ? 'View' : 'Edit'} Settings`} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <Form disabled={isViewOnly} layout="vertical" form={form} onFinish={onFinish}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Google map key" name="googleMapKey" rules={[{ required: true, message: "Please enter key" }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                {/* <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item rules={[{ required: true, message: "Picture is required" }]} label="Main Cover Picture (1920 x 1080)" name="picture" valuePropName="fileList" getValueFromEvent={(e) => e?.fileList || []}>
                            <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
                                <Button icon={<UploadOutlined />}>Click to Upload</Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                </Row> */}

                {!isViewOnly && <Form.Item style={{
                    marginTop: '5rem'
                }}>
                    <Button type="primary" htmlType="submit">Update</Button>
                </Form.Item>}
            </Form>
        </Modal>
    );
};

export default EditSettingModal;
